import { render, staticRenderFns } from "./healthArchiveCC.vue?vue&type=template&id=b4caad5c&scoped=true"
import script from "./healthArchiveCC.vue?vue&type=script&lang=js"
export * from "./healthArchiveCC.vue?vue&type=script&lang=js"
import style0 from "./healthArchiveCC.vue?vue&type=style&index=0&id=b4caad5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4caad5c",
  null
  
)

export default component.exports